import { useMemo } from 'react'
import { useGetIntakeforms } from '@/api/generated/intake-form-template/intake-form-template'
import { extractIntakeFormsList } from '@/hooks/extractIntakeFormsList'
import { mapIntakeFormError } from './mapIntakeFormError'

/**
 * Reads the intake-form collection. Replaces the `getIntakeFormsCollection` thunk +
 * GET_INTAKE_FORMS_COLLECTION* reducer flow (intakeFormsList / loading / error).
 *
 * The old flow refetched on navigation and after a create; React Query refetches on mount,
 * and the create mutation invalidates this query, preserving that behavior. `error` mirrors
 * the reducer's collection error mapping so the table's ErrorAlert is unchanged.
 *
 * The backend returns the list under an `{ IntakeForms: [...] }` wrapper while the generated
 * contract types a bare array; `extractIntakeFormsList` accepts either shape.
 */
export const useIntakeForms = () => {
  const query = useGetIntakeforms()
  const intakeFormsList = useMemo(() => extractIntakeFormsList(query.data), [query.data])
  const error = query.error ? mapIntakeFormError(query.error) : ''

  return { ...query, intakeFormsList, loading: query.isLoading, error }
}
